module.exports = {
  siteTitle: 'Gustavo Oliveira - Frontend Developer', // <title>
  manifestName: 'Gustavo Oliveira \'s Portifolio',
  manifestShortName: 'GughogResume', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#424242',
  manifestThemeColor: '#424242',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/portfolio`, // This path is subpath of your hosting https://domain/portfolio
  firstName: 'Gustavo',
  lastName: 'Oliveira',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/gughog',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://linkedin.com/in/gustavo-giovanne/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/gughog42',
    },
    {
      icon: 'fab fa-whatsapp',
      name: 'Whatsapp',
      url: 'https://wa.me/5582996831646'
    },
    {
      icon: 'fas fa-envelope',
      name: 'Email',
      url: 'mailto:gustavogiovanne3@gmail.com'
    }
  ],
  // job experiences
  experiences: [
    {
      title: 'Jr Developer Analyst',
      company: 'OFM Systems / OG1 Systems',
      date: 'August 2019 - Present',
      description: 'As Front-end Developer / Jr. Analyst, I worked on the development process of an ERP. I have built the major part of the frontend using Vue.js, worked on some backend related tasks using Node.js and Typescript, wrote documentation for the tools we use, and maintained the Github repository for the frontend.'
    },
    {
      title: 'Freelancer Developer',
      company: 'Independent',
      date: 'August 2016 - Present',
      description: 'As an independent developer, I have built some minor websites in internal tools for local companies and merchants and other personal projects. Mainly worked with HTML5, CSS3, Javascript ES6+, Typescript, React.js, React Native, Vue.js, Node.js, Express.js, Postgres, MongoDB, and other tools.'
    },
    {
      title: 'Trainee Frontend Developer',
      company: 'Heydev',
      date: 'November 2018 - May 2019',
      description: 'As a trainee on the frontend side in this startup, I have worked with my team building websites for other small companies and the own company\'s website. Worked mainly using Vue.js.'
    },
  ],
  education: [
    {
      institution: 'Federal University of Alagoas',
      degree: 'Bachelor of Information Systems',
      date: '2019 - 2023'
    },
    {
      institution: 'University Estacio de Sa',
      degree: 'Bachelor of Business Administration',
      date: '2014 - 2018'
    },
    {
      institution: 'Udemy, Lynda, Youtube, etc.',
      degree: 'Open Courses',
      date: 'Always learning '
    },
  ],
  skills: [
    { name: 'HTML', devicon: 'devicon-html5-plain-wordmark colored' },
    { name: 'CSS', devicon: 'devicon-css3-plain-wordmark colored' },
    { name: 'Javascript', devicon: 'devicon-javascript-plain colored' },
    { name: 'Typescript', devicon: 'devicon-typescript-plain colored' },
    { name: 'React.js', devicon: 'devicon-react-original-wordmark colored' },
    { name: 'Vue.js', devicon: 'devicon-vuejs-plain-wordmark colored' },
    { name: 'Node.js', devicon: 'devicon-nodejs-plain-wordmark colored' },
    { name: 'Express', devicon: 'devicon-express-original-wordmark colored' },
    { name: 'Postgres', devicon: 'devicon-postgresql-plain-wordmark colored' },
    { name: 'MongoDB', devicon: 'devicon-mongodb-plain-wordmark colored' },
    { name: 'Git', devicon: 'devicon-git-plain-wordmark colored' },
    { name: 'Github', devicon: 'devicon-github-plain-wordmark colored' },
  ],
  projects: [
    {
      name: 'Movies Dev App',
      preview: 'https://i.imgur.com/1EHCRew.png',
      description: 'An React application to search movies from TMDB database and manage a watch later and favorites movie list. It was made with React, Typescript and Styled Components.',
      source: 'https://github.com/gughog/react-movies-dev-app',
      live: 'https://moviesdev.netlify.app/',
      techs: ['React', 'Styled Components', 'Typescript', 'Netlify', 'Jest']
    },
    {
      name: 'SMTIV Tools',
      preview: 'https://i.imgur.com/p7sQC9U.png',
      description: 'An app for searching data about Shin Megami Tensei IV game. I built the frontend and backend for this app and deployed the backend Heroku and the frontend on Netlify.',
      source: 'https://github.com/gughog/smtivtools-frontend',
      live: 'https://smtivtools.netlify.com/',
      techs: ['React', 'Styled Components', 'Typescript', 'Node.js', 'Express', 'Heroku', 'Netlify']
    },
    {
      name: 'Budget manager app',
      preview: 'https://i.imgur.com/lny7r2b.png',
      description: '(in development) Cross platform for helping your budget management. I am building the backend, frontend and the mobile too. Using React with Typescript and Node.js',
      source: null,
      live: null,
      techs: ['React', 'Typescript', 'Material UI', 'Styled Components', 'Node.js', 'Express', 'Heroku', 'Netlify']
    },
    {
      name: 'gughog.github.io',
      preview: 'https://i.imgur.com/ZyqEjYi.png',
      description: 'My blog, built with Gatsby.js and React. It is a heavily modified Gatsby theme and I am adding some functionalities over time. I publish posts with markdown files.',
      source: 'https://github.com/gughog/gughog.github.io/tree/development',
      live: 'https://gughog.github.io',
      techs: ['React', 'Gatsby.js', 'Markdown']
    },
    {
      name: 'Clr.js',
      preview: 'https://i.imgur.com/7mFXx0I.png',
      description: 'A tiny and simple library for Node.js to put some colors on node output. It is published on NPM and was made with Typescript',
      source: 'https://github.com/gughog/clr-js',
      live: 'https://www.npmjs.com/package/clr-js',
      techs: ['Node.js', 'Typescript', 'NPM']
    }
    // {
    //   name: '',
    //   preview: '',
    //   description: '',
    //   techs: []
    // },
  ],
  email: 'gustavogiovanne3@gmail.com',
  phone: '+55 (82) 99683-1646',
  address: 'Alagoas, Brazil',
};
